import { render } from "./SetupFormView.vue?vue&type=template&id=1635d321&scoped=true&ts=true"
import script from "./SetupFormView.vue?vue&type=script&lang=ts"
export * from "./SetupFormView.vue?vue&type=script&lang=ts"

import "./SetupFormView.vue?vue&type=style&index=0&id=1635d321&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1635d321"]])

export default __exports__